import jsQR from 'jsqr';

/**
 * Decodes a QR code from a static uploaded image file. Same canvas+jsQR primitive as
 * components/QrScanner.tsx (which decodes live camera frames instead) — draws the image to an
 * off-screen canvas at its natural resolution, reads the pixel data, and runs jsQR on it.
 */
export async function decodeQrFromImageFile(file: File): Promise<string | null> {
  const url = URL.createObjectURL(file);
  try {
    const image = await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error('image failed to load'));
      img.src = url;
    });

    const canvas = document.createElement('canvas');
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx || !canvas.width || !canvas.height) return null;
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const found = jsQR(data.data, canvas.width, canvas.height, { inversionAttempts: 'dontInvert' });
    return found?.data ?? null;
  } catch {
    return null;
  } finally {
    URL.revokeObjectURL(url);
  }
}
